import {
  BlogEditorContextMenuActionEnum,
  BlogEditorLeftToolBarActionEnum,
  BlogEditorRightToolBarActionMarkEnum,
} from '@doltech/utils/lib/constants';
import { values } from 'lodash';
import { types as t } from 'mobx-state-tree';
import { useCreateStore, useProvider, useStore } from 'mobx-store-provider';
import * as React from 'react';

import { BlogEditorContextMenuStore } from './blog-editor-context-menu.store';
import { BlogEditorLeftSidebarStore } from './blog-editor-left-sidebar.store';
import { BlogEditorRightSidebarStore } from './blog-editor-right-sidebar.store';
import {
  BlogEditorSelectStateStore,
  initialBlogEditorSelectState,
} from './blog-editor-select-state.store';

const getInitializeBlogEditorStore = () => {
  return {};
};

export const BlogEditorStore = t.model('BlogEditorStore', {
  selectState: t.optional(BlogEditorSelectStateStore, initialBlogEditorSelectState),

  contextMenu: t.optional(BlogEditorContextMenuStore, {
    visible: false,
    menuEnabled: values(BlogEditorContextMenuActionEnum),
  }),

  leftSideBar: t.optional(BlogEditorLeftSidebarStore, {
    menuEnabled: values(BlogEditorLeftToolBarActionEnum),
  }),

  rightSideBar: t.optional(BlogEditorRightSidebarStore, {
    menuEnabled: values(BlogEditorRightToolBarActionMarkEnum),
    menuActive: [],
  }),
});

export const useBlogEditorStore = () => {
  return useStore(BlogEditorStore);
};

export const withBlogEditorStore = (Component: any) => (props: any) => {
  const blogEditorCreateStore = useCreateStore(BlogEditorStore, getInitializeBlogEditorStore());
  const BlogEditorStoreProvider = useProvider(BlogEditorStore);

  return (
    <BlogEditorStoreProvider value={blogEditorCreateStore}>
      <Component {...props} />
    </BlogEditorStoreProvider>
  );
};
